import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as formReducer } from 'redux-form';
import { localizeReducer } from "react-localize-redux";
import accountRecoveryReducer from './accountRecovery.reducer';
import authReducer from './auth.reducer';
import contactsReducer from './contacts.reducer';
import profileReducer from './profile.reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['profile', 'auth', 'contacts'],
};


const rootReducer = combineReducers({
  accountRecovery: accountRecoveryReducer,
  auth: authReducer,
  contacts: contactsReducer,
  form: formReducer,
  profile: profileReducer,
  localize: localizeReducer,
});


export default persistReducer(persistConfig, rootReducer);



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js